module.exports = __webpack_public_path__ + "img/icon_12.52db6ce6.png";